import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Spinner, Alert } from 'react-bootstrap';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';

const EmailSettings = () => {
  const [bookingText, setBookingText] = useState('');
  const [email1, setEmail1] = useState('');
  const [email2, setEmail2] = useState('');
  const [enableCancel, setEnableCancel] = useState('no');
  const [smtpSettings, setSmtpSettings] = useState('hostgator'); // ← New state
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [id, setID] = useState('');

  useEffect(() => {
    DataService.getEmailSettings()
      .then((res) => {
        if (res.data.data) {
          const { bookingText, email1, email2, enableCancel, smtip_settings, id } = res.data.data;
          setBookingText(bookingText || '');
          setEmail1(email1 || '');
          setEmail2(email2 || '');
          setEnableCancel(enableCancel || 'no');
          setSmtpSettings(smtip_settings || 'hostgator'); // ← Load from DB
          setID(id);
        }
      })
      .catch(() => {
        setError('Failed to load email settings');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSave = () => {
    setError('');
    setSuccessMsg('');
    setLoading(true);

    if (!bookingText.trim()) {
      setError('Booking request text is required.');
      setLoading(false);
      return;
    }

    if (!email1.trim() || !email2.trim()) {
      setError('Both email addresses are required.');
      setLoading(false);
      return;
    }

    const emailPattern = /\S+@\S+\.\S+/;
    if (!emailPattern.test(email1) || !emailPattern.test(email2)) {
      setError('Please enter valid email addresses.');
      setLoading(false);
      return;
    }

    const data = {
      bookingText,
      email1,
      email2,
      enableCancel,
      smtp_settings: smtpSettings, // ← Include in payload
      id,
    };

    DataService.saveEmailSettings(data)
      .then(() => {
        toast.success('Settings Saved Successfully.');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error('Failed to save settings');
      });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <Card className="p-4">
        <h5>Email Settings</h5>

        {loading ? (
          <div className="text-center"><Spinner animation="border" /></div>
        ) : (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Booking Request Text (Email)</Form.Label>
              <Form.Control
                type="text"
                value={bookingText}
                onChange={(e) => setBookingText(e.target.value)}
                placeholder="Enter text shown in booking request Email"
                className="px-2"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address 1</Form.Label>
              <Form.Control
                type="email"
                value={email1}
                onChange={(e) => setEmail1(e.target.value)}
                placeholder="Enter first email"
                className="px-2"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address 2</Form.Label>
              <Form.Control
                type="email"
                value={email2}
                onChange={(e) => setEmail2(e.target.value)}
                placeholder="Enter second email"
                className="px-2"
              />
            </Form.Group>

            {/* Enable Cancel Option */}
            <Form.Group className="mb-3">
              <Form.Label>Enable Cancel Button (Customer)</Form.Label>
              <div>
                <Form.Check
                  inline
                  label="Yes"
                  name="enableCancel"
                  type="radio"
                  id="cancel-yes"
                  value="yes"
                  checked={enableCancel === 'yes'}
                  onChange={(e) => setEnableCancel(e.target.value)}
                />
                <Form.Check
                  inline
                  label="No"
                  name="enableCancel"
                  type="radio"
                  id="cancel-no"
                  value="no"
                  checked={enableCancel === 'no'}
                  onChange={(e) => setEnableCancel(e.target.value)}
                />
              </div>
            </Form.Group>

            {/* ← SMTP Provider Selection */}
            <Form.Group className="mb-3">
              <Form.Label>SMTP Mail Provider</Form.Label>
              <Form.Select
                value={smtpSettings}
                onChange={(e) => setSmtpSettings(e.target.value)}
                className="form-control px-2"
              >
                <option value="hostgator">HostGator</option>
                <option value="gmail">Gmail</option>
              </Form.Select>
              <Form.Text className="text-muted">
                {smtpSettings === 'gmail'
                  ? '⚠️ Using Gmail SMTP — recommended when HostGator emails go to spam.'
                  : '✅ Using HostGator SMTP — default mail server.'}
              </Form.Text>
            </Form.Group>

            {error && <Alert variant="danger">{error}</Alert>}
            {successMsg && <Alert variant="success">{successMsg}</Alert>}

            <Button variant="primary" onClick={handleSave} style={{ width: '100px' }}>
              Save
            </Button>
          </>
        )}
      </Card>
    </>
  );
};

export default EmailSettings;